import React from 'react';

import './Socials.scss';

const Socials = props => {
    const hostURL = window.location.host;
    const pathURL = window.location.pathname;

    return (
        <div className='Socials'>
            <div className="Socials__text">
                Share
            </div>
            <a rel='noreferrer' href={`mailto:?&subject=Sharing:%20Product%20Lifecycle%20Management%20assessment%20tool&cc=&bcc=&body=Product%20Lifecycle%20Management%20assessment%20tool%0A%0Ahttps://${hostURL}${pathURL}`} className="Socials__icon Socials__icon--1"></a>
            <a rel='noreferrer' href={`https://www.facebook.com/sharer/sharer.php?u=https://${hostURL}${pathURL}`} target="_blank" className="Socials__icon Socials__icon--2">
            </a>
            <a rel='noreferrer' href={`https://twitter.com/intent/tweet?url=https://${hostURL}${pathURL}&text=Product Lifecycle%20Management%20assessment%20tool`} className="Socials__icon Socials__icon--3" target="_blank">    
            </a>  
            <a rel='noreferrer' href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${hostURL}${pathURL}`} className="Socials__icon Socials__icon--4" target="_blank">
            </a>                    
            {/* <div className="Socials__icon Socials__icon--1"></div>
            <div className="Socials__icon Socials__icon--2"></div>
            <div className="Socials__icon Socials__icon--3"></div>
            <div className="Socials__icon Socials__icon--4"></div> */}
        </div>    
    )
}

export default Socials;
